/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";
import { CustomerAddressManager } from "./CustomerAddressManager";

export const AddressesSubpage = defineComponent({
  setup() {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-6">
        <div class="">
          <h2 class="text-2xl font-bold mb-2 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">
              location_on
            </span>
            {t("customer.account.my_addresses")}
          </h2>
          <p class="text-base-content/60">
            {t("customer.account.addresses_copy")}
          </p>
        </div>

        <CustomerAddressManager />
      </div>
    );
  },
});
